import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslatePipe } from '../translate/translate.pipe';

@Pipe({
  name: 'emojiTypeImage'
})
export class EmojiTypeImagePipe implements PipeTransform {

  transform(value: any) {
    if (!value) {
      return './assets/img/icons/exp/outline_like.png';
    }

    switch (value.toString()) {
      case '1':
        return `./assets/img/icons/exp/001-like.png`;
      case '2':
        return `./assets/img/icons/exp/002-celebrate-master.png`;
      case '3':
        return `./assets/img/icons/exp/003-love.png`;
      case '4':
        return `./assets/img/icons/exp/004-insightful.png`;
      case '5':
        return `./assets/img/icons/exp/005-curiouss.png`;
      case '6':
        return `./assets/img/icons/exp/006-sad-master.png`;
      case '10':
        return `./assets/img/icons/exp/007-haha-master.png`;
      case '8':
        return `./assets/img/icons/exp/icon-checkin.png`;
      case '9':
        return `./assets/img/icons/exp/icon-checkout.png`;
      default:
        return './assets/img/icons/exp/outline_like.png';
    }
  }

}
@Pipe({
  name: 'emojiTypeName'
})
export class EmojiTypeNamePipe implements PipeTransform {

  // constructor(public tr: CustomTranslatePipe) { }

  transform(value: any) {
    if (!value) {
      return 'Like';
    }

    switch (value.toString()) {
      case '1':
        return 'Like';
      case '2':
        return 'Celebrate';
      case '3':
        return 'Love';
      case '4':
        return 'Insightful';
      case '5':
        return 'Curious';
      case '6':
        return 'Sad';
      case '10':
        return 'Laugh';
      case '8':
        return 'Checkin';
      case '9':
        return 'Checkout';
      default:
        return 'Like';
    }
  }

}